<template>
  <div>
    <header class="header content">
      <div class="header-video">
        <video ref="video" src="@/assets/videos/background.mp4" muted autoplay loop></video>
      </div>
      <div class="header-content">
        <h1>CENTRO DE DESARROLLO GLOBAL</h1>
        <hr>
        <p>UNIVERSIDAD PRIVADA BOLIVIANA</p>
        <a href="#description-section" v-smooth-scroll class="btn">Conoce más</a>
      </div>
    </header>
    <div class="sound-button">
      <v-btn icon @click="sound()">
        <font-awesome-icon class="music-icon" icon="music"/>
      </v-btn>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    sound: function () {
      this.$refs.video.muted = !this.$refs.video.muted
    }
  }
}
</script>

<style scoped>
h1 {
  color: white;
}

.header {
  height: 100vh;
  display: flex;
  align-items: center;
  color: #fff;
}

.content {
  max-width: 40rem;
  padding-left: 1rem;
  padding-right: 1rem;
  margin: auto;
  text-align: center;
}

.header-video {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  overflow: hidden;
  filter: brightness(0.7);
}

.sound-button {
  position: absolute;
  top: 85vh;
  left: 5vw;
}

.music-icon {
  width: 5vw;
  height: 5vh;
  color: white;
}

.header-video video {
  min-width: 100%;
  min-height: 100%;
}

.header-content {
  z-index: 2;
}

.header-content h1 {
  font-size: 3.5rem;
  margin-bottom: 0;
}

.header-content p {
  font-size: 2rem;
  display: block;
  padding-bottom: 2rem;
}

.btn {
  background: #292F6D;
  border-radius: 30px;
  color: #fff;
  font-size: 1.2rem;
  padding: 1rem 2rem;
  text-decoration: none;
}

.btn:hover{
  background: #A5B433;
}

@media (max-width: 960px) {
  .content {
    padding: 0 3rem 0 3rem;
  }
}
</style>
